import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTwitter,
  faFacebookSquare,
  faFacebookF,
  faGoogle,
  faLinkedin,
  faYoutube,
  faInstagram,
  faYelp,
  faPinterestP,
  faPinterest,
  faRedditAlien,
  faVk,
} from '@fortawesome/free-brands-svg-icons'

const SocialIcons = () => (
  <div>
    <a
      target="_blank"
      rel="noopener noreferrer nofollow"
      href="https://www.instagram.com/longmakeup_"
      className="w3-bar-item w3-button"
      aria-label="Instagram"
    >
      <FontAwesomeIcon icon={faInstagram} />
      {/* <FontAwesomeIcon icon={faInstagram} style={{ color: '#3f729b' }} /> */}
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer nofollow"
      href="https://www.facebook.com/LongMakeupInc/"
      className="w3-bar-item w3-button"
      aria-label="Facebook"
    >
      <FontAwesomeIcon icon={faFacebookF} />
      {/* <FontAwesomeIcon icon={faFacebookSquare} style={{ color: '#3b5998' }} /> */}
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer nofollow"
      href="https://twitter.com/longmakeup1"
      className="w3-bar-item w3-button"
      aria-label="Twitter"
    >
      <FontAwesomeIcon icon={faTwitter} />
      {/* <FontAwesomeIcon icon={faTwitter} style={{ color: '#55acee' }} /> */}
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer nofollow"
      href="https://www.yelp.com/biz/longmakeup-new-york-5"
      className="w3-bar-item w3-button"
      aria-label="Yelp"
    >
      <FontAwesomeIcon icon={faYelp} />
      {/* <FontAwesomeIcon icon={faYelp} style={{ color: '#af0606' }} /> */}
    </a>
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faPinterest} />
      <FontAwesomeIcon icon={faPinterestP} style={{ color: '#cc2127' }} />
    </a> */}
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faGoogle} />
      <FontAwesomeIcon icon={faGoogle} style={{ color: '#dd4b39' }} />
    </a> */}
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faLinkedin} />
      <FontAwesomeIcon icon={faLinkedin} style={{ color: '#0976b4' }} />
    </a> */}
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faYoutube} />
      <FontAwesomeIcon icon={faYoutube} style={{ color: '#e52d27' }} />
    </a> */}
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faRedditAlien} />
      <FontAwesomeIcon icon={faRedditAlien} style={{ color: '#ff4500' }} />
    </a> */}
    {/* <a target="_blank" rel="noopener noreferrer nofollow" href="/" className="w3-bar-item w3-button">
      <FontAwesomeIcon icon={faVk} />
      <FontAwesomeIcon icon={faVk} style={{ color: '#45668e' }} />
    </a> */}
  </div>
)

export default SocialIcons
